/**
 * Z-index per il layer di disegno geometrie.
 * I layer configurati hanno z-index espliciti (da buildGroupedLayers):
 * senza un valore alto il drawing layer finirebbe sotto di essi
 * (default OL = 0).
 */
export const DRAWING_LAYER_Z_INDEX = 9999;

/**
 * Z-index per il layer di evidenziazione risultati identify.
 * Subito sotto il drawing layer per non coprire le geometrie in fase
 * di modifica.
 */
export const IDENTIFY_HIGHLIGHT_Z_INDEX = 9998;

export class MapWidgetLogic {
  /**
   * Abilita le funzionalità catastali del widget mappa: il preset
   * "Particelle Catastali" e la ricerca per particella. Le intersezioni
   * custom (non catastali) sono invece gestite da
   * isAdvancedMapWidgetEnabled().
   */
  static isCadastralEnabled(): boolean {
    return process.env.ENABLE_CADASTRAL_PARTICLES === 'true';
  }

  /** URL del servizio catastale configurato per l'ambiente corrente */
  static getCadastralLayerUrl(): string {
    return process.env.CADASTRAL_LAYER_URL ?? '';
  }

  /**
   * Abilita le funzionalità avanzate del widget mappa (identify, mappa
   * estesa, intersezioni custom). Disattivo di default: si attiva
   * impostando ENABLE_ADVANCED_MAP_WIDGET=true (profilo "avanzato").
   */
  static isAdvancedMapWidgetEnabled(): boolean {
    return process.env.ENABLE_ADVANCED_MAP_WIDGET === 'true';
  }
}
